<template>
    <header id="header" class="admin--header">
    </header>
</template>
<script>
export default {
  name: 'HeaderView'
}
</script>
